<template>
  <button
    class="tooth-popup"
    type="button"
    v-bind:class="{ flip, selected }"
    v-on:click="toggle">
    <svg
      class="tooth-popup__parts"
      width="26"
      height="51"
      viewBox="0 0 26 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M16.6651 25.2446C17.3471 23.5686 17.8066 17.8952 17.9512 15.2681L6.63715 14.3203C6.72489 18.6934 7.02436 29.1255 7.52035 35.8697C8.01633 42.6138 10.9819 46.8605 12.4027 48.1408C12.6352 48.4068 13.2707 48.6795 13.9527 47.642C14.8051 46.345 15.1926 41.3069 15.2701 37.865C15.3476 34.4231 15.8126 27.3397 16.6651 25.2446Z" />
      <path d="M6.74585 1.85067L17.518 1.80078C18.0344 1.86725 18.5674 1.93864 18.9931 2.23846C19.0783 2.29853 19.1662 2.36845 19.2534 2.44959C19.9907 3.13587 20.0141 4.25407 19.9705 5.26043C19.8813 7.31857 19.5688 10.4878 18.758 13.3736C18.5569 14.0893 18.2793 14.7183 17.9516 15.2691C16.7678 17.2593 14.9304 18.2294 13.6884 18.5813C13.3023 18.6908 12.8992 18.711 12.4979 18.711C11.7155 18.711 10.9272 18.6164 10.2247 18.2723C9.14565 17.7438 7.80049 16.8142 7.13334 15.4687C6.96462 15.1284 6.79845 14.7392 6.6376 14.3213C6.60043 14.2248 6.56416 14.1266 6.52876 14.0269C5.31633 10.6153 4.81632 6.911 5.0409 3.29727C5.07249 2.78886 5.25302 2.44022 5.4635 2.21175C5.77768 1.87072 6.28216 1.85067 6.74585 1.85067Z" />
    </svg>
    <div class="tooth-popup__number">{{number}}</div>
  </button>
</template>

<script>
import popupTeethMixin from '@/mixins/popupTeethMixin';

export default {
  mixins: [popupTeethMixin],
  name: 'ToothDown1',
};
</script>

<style>
</style>
